import { render, staticRenderFns } from "./BaseRecords.vue?vue&type=template&id=1f473436"
import script from "./BaseRecords.vue?vue&type=script&lang=js"
export * from "./BaseRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports